import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: 'rgb(255, 255, 255)', // Blanco (primary color)
        },
        secondary: {
            main: 'rgb(51, 184, 177)', // Nuevo color secundario
        },
        background: {
            default: 'rgb(249, 249, 249)', // Fondo general
            paper: 'rgb(255, 255, 255)', // Fondo de componentes
        },
        text: {
            primary: 'rgb(53, 54, 74)', // Color principal de fuente
            secondary: 'rgb(0, 0, 0)', // Color secundario de fuente
        },
    },
    typography: {
        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    components: {
                MuiButton: {
                    defaultProps: {
                        color: 'secondary',
                    },
                    styleOverrides: {
                        root: {
                            fontWeight: 700,
                        },
                        contained: {
                            backgroundColor: 'rgb(51, 184, 177)',
                            color: 'rgb(0, 0, 0)',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'rgb(51, 184, 177)',
                                opacity: 0.9,
                                boxShadow: 'none',
                            },
                        },
                    },
                },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: 'rgb(249, 249, 249)', // Fondo general
                    color: 'rgb(53, 54, 74)', // Color de fuente principal
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        backgroundColor: 'rgb(255, 255, 255)', // Fondo de componentes para inputs
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        backgroundColor: 'rgb(255, 255, 255)', // Fondo de componentes para selects
                    },
                },
            },
        },
        MuiPagination: {
            styleOverrides: {
              root: {
                color: '#fafafa', // Light text for pagination
              },
              ul: {
                '& .Mui-selected': {
                  backgroundColor: '#0088cc', // Highlight selected page
                  color: '#ffffff', // White text for selected page
                },
                '& .MuiPaginationItem-root': {
                  color: '#fafafa', // Light text for pagination items
                },
              },
            },
          },
        
        
    },
});

export default theme;